<template>
  <div class="bpjs-page">
        <PageHeader icon="fas fa-chart-line">
      <template #title>
        Dashboard Satu Sehat
      </template>
      <template #subtitle>
        Pantau status pengiriman dan riwayat sinkronisasi data ke server Satu Sehat.
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <b-tabs content-class="mt-3">
              <b-tab title="Rekam Medis" active> 
                <ReturnMedicalRecord />
              </b-tab>
              <b-tab title="Dokter">
                <ReturnDoctor />
              </b-tab>
              <b-tab title="Ruangan">
                <ReturnRoom />
              </b-tab>
              <b-tab title="Gedung">
                <ReturnBuilding />
              </b-tab>
              <b-tab title="Departmen">
                <ReturnDepartemen />
              </b-tab>
              <b-tab title="Rekam Medis gagal posting"> 
                <MedicalRecordReupload />
              </b-tab>
            </b-tabs>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ReturnMedicalRecord from "@/component/satu-sehat/ReturnMedicalRecord.vue";
import MedicalRecordReupload from "@/component/satu-sehat/MedicalRecordReupload.vue";
import ReturnDepartemen from "@/component/satu-sehat/ReturnDepartemen.vue";
import ReturnBuilding from "@/component/satu-sehat/ReturnBuilding.vue";
import ReturnRoom from "@/component/satu-sehat/ReturnRoom.vue";
import ReturnDoctor from "@/component/satu-sehat/ReturnDoctor.vue";
export default {
  components: {
    Card,
    ReturnMedicalRecord,
    MedicalRecordReupload,
    ReturnDepartemen,
    ReturnBuilding,
    ReturnRoom,
    ReturnDoctor,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Satu Sehat" },
      { title: "Dashboard" },
    ]);
  },
};
</script>

<style>
</style>